import { cn } from '@/utils'
import { SidebarProvider, SidebarInset } from '@/components/ui/sidebar'
import { MinimalLayout } from '@/components/layouts/MinimalLayout'
import { Navbar } from '@/components/nav/Navbar'

import { DocumentPage } from './components/DocumentPage'
import { ControlBar } from './components/ControlBar'
import { PageSideNavigation } from './components/PageSideNavigation'
import { DocumentToolbar } from './components/DocumentToolbar'
import { TechnicianComments } from './components/TechnicianComments'
import { Spinner } from '@/components/ui/spinner'
import { CADVersionProcessingHelper } from '../CADPage/components/CadVersionProcessingHelper'

import { usePreloadImages } from '@/utils/hooks/usePreloadImages'
import { useTechnicianPageStore } from './hooks/useTechnicianPageStore'
import { useCADVersionProcessing } from '@/services/hooks/cad_versions'

export const TechnicianPage = () => {
  usePreloadImages()

  const {
    isLoading,
    isComplete,
    isProcessing,
    data: cadVersionProcess,
  } = useCADVersionProcessing({
    pollDocumentVersions: true,
  })

  const commentsEnabled = useTechnicianPageStore(
    (state) => state.commentsEnabled,
  )

  return (
    <MinimalLayout>
      <Navbar disableHomeButton>
        <div className="flex items-center space-x-4 h-10 py-8 px-10 w-full">
          <div className="flex items-center justify-between w-full">
            <div className="flex items-center h-16 w-full"></div>
          </div>
        </div>
      </Navbar>
      {isLoading && <Spinner />}
      {isComplete && (
        <SidebarProvider
          style={{
            height: 'calc(100vh - 68px)',
          }}
        >
          <PageSideNavigation />
          <SidebarInset>
            <main className="flex flex-col justify-self-center space-y-2 w-full">
              <DocumentToolbar />
              <div className="flex items-center">
                <div className="flex flex-col justify-self-center space-y-6 w-full px-4 overflow-auto">
                  <div
                    className={cn(
                      'self-center p-0 h-[calc(100vh-210px)] max-[767px]:w-[100vw]',
                      {
                        'w-[calc(100vw-40rem)]': commentsEnabled,
                        'w-[calc(100vw-288px)]': !commentsEnabled,
                      },
                    )}
                  >
                    <div
                      className={cn(
                        'h-full w-full justify-items-center scale-100 xl:scale-100 lg:scale-95',
                        {
                          'lg:scale-75 max-[840px]:scale-50 sm:scale-75':
                            commentsEnabled,
                          'md:scale-50 max-[840px]:scale-50 sm:scale-75':
                            !commentsEnabled,
                        },
                      )}
                    >
                      <DocumentPage />
                    </div>
                  </div>
                  <ControlBar />
                </div>
                <TechnicianComments />
              </div>
            </main>
          </SidebarInset>
        </SidebarProvider>
      )}
      {isProcessing && (
        <CADVersionProcessingHelper
          cadVersionId={cadVersionProcess.cadVersionId}
          status={cadVersionProcess.processingStatus}
          hasNoDownloadUrl={cadVersionProcess.hasNoDownloadUrl}
        />
      )}
    </MinimalLayout>
  )
}
